module.exports = __webpack_public_path__ + "img/post_pic4.ddf739b9.png";